import { useAxiosConfig } from '@shared/api/AxiosConfigProvider';
import {
  getCompanyReportsTagsListQueryKey,
  useCompanyReportsTagsCreate,
  useCompanyReportsTagsList,
} from '@shared/api/lib/company-reports/company-reports';
import { useQueryClient } from '@tanstack/react-query';

export const useCreateTag = () => {
  const queryClient = useQueryClient();
  return useCompanyReportsTagsCreate({
    request: useAxiosConfig(),
    mutation: {
      onSuccess: () => {
        queryClient.invalidateQueries(getCompanyReportsTagsListQueryKey());
      },
    },
  });
};

export const useGetTags = () => {
  return useCompanyReportsTagsList({
    request: useAxiosConfig(),
  });
};
